import React from "react";
import { RadioProperties } from "./RadioProperties";
import './RadioButton.css';
import CheckIcon from "../../resources/wrappers/CheckIcon";

export class RadioButton extends React.Component<RadioProperties, any> {

    render() {
        const { selected, textName, textDescription, value } = this.props;
        return <div className="radio-container" onClick={() => {
            //@ts-ignore
            this.props.onChange(value);
        }}>
            <div className={"radio-radio-container"}>
                {
                    (value === selected) && <div className={"radio-selected-circle"}>
                        <CheckIcon height={"27px"} width={"38px"} color={"#FFFFFF"} />
                    </div>
                }
                {
                    (value !== selected) && <div className={"radio-unselected-circle"} />
                }
            </div>
            <div className="radio-text-container">
                <p className={this.props.titleClass !== undefined ? this.props.titleClass : "radio-text-title"}>{textName}</p>
                <p className={this.props.subtitleClass !== undefined ? this.props.subtitleClass : "radio-text-description"}>{textDescription}</p>
            </div>
        </div>
    }
}